import React, { useState } from "react";
import { HashRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";

function Sidebar({ menuOpen, setMenuOpen }) {
  return (
    <aside className={`bg-gray-950 p-6 flex flex-col items-start space-y-4 fixed h-full top-0 left-0 z-40 transition-transform duration-300 transform ${menuOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 w-60`}>
      <Link to="/" onClick={() => setMenuOpen(false)}>
        <img
          src="/logo-canil.png"
          alt="Logo Canil"
          className="h-32 w-auto mb-6 transition-transform duration-300 hover:scale-105 hover:drop-shadow-lg"
        />
      </Link>
      <nav className="flex flex-col space-y-4 text-base w-full">
        <Link to="/" onClick={() => setMenuOpen(false)} className="hover:bg-gray-800 p-2 rounded">Início</Link>
        <Link to="/hospedagem" onClick={() => setMenuOpen(false)} className="hover:bg-gray-800 p-2 rounded">Hospedagem</Link>
        <Link to="/adestramento" onClick={() => setMenuOpen(false)} className="hover:bg-gray-800 p-2 rounded">Adestramento</Link>
        <Link to="/cursos" onClick={() => setMenuOpen(false)} className="hover:bg-gray-800 p-2 rounded">Cursos Online</Link>
        <Link to="/loja" onClick={() => setMenuOpen(false)} className="hover:bg-gray-800 p-2 rounded">Loja</Link>
        <Link to="/contato" onClick={() => setMenuOpen(false)} className="hover:bg-gray-800 p-2 rounded">Contato</Link>
      </nav>
    </aside>
  );
}

function Contato() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const assunto = searchParams.get("assunto") || "";

  return (
    <section className="px-4 py-10 bg-gray-800 text-center">
      <h2 className="text-2xl font-bold mb-4">Entre em Contato</h2>
      <form
        className="max-w-md mx-auto text-left space-y-4"
        action="https://formspree.io/f/mpwvywna"
        method="POST"
      >
        <input name="nome" type="text" placeholder="Nome" className="w-full p-3 rounded bg-gray-900 text-white" required />
        <input name="telefone" type="tel" placeholder="Telefone (DDD + número)" className="w-full p-3 rounded bg-gray-900 text-white" pattern="\(\d{2}\)\s?\d{4,5}-\d{4}" title="Formato esperado: (11) 91234-5678" required />
        <input name="email" type="email" placeholder="Email" className="w-full p-3 rounded bg-gray-900 text-white" required />
        <textarea name="mensagem" placeholder="Mensagem" className="w-full p-3 rounded bg-gray-900 text-white h-32" defaultValue={assunto}></textarea>
        <button type="submit" className="px-6 py-3 bg-blue-600 hover:bg-blue-500 rounded-xl text-white font-semibold">Enviar</button>
      </form>
    </section>
  );
}

function PaginaInicial() {
  return (
    <section className="px-6 py-16 bg-gray-900 flex flex-col md:flex-row items-center justify-center text-white min-h-screen">
      <style>
        {`
        @keyframes float {
          0% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0); }
        }

        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }

        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out forwards;
        }
        `}
      </style>
      <div className="max-w-xl text-center md:text-left">
        <h1 className="text-4xl md:text-5xl font-bold leading-tight text-white mb-6 animate-fade-in-up">
          Tradição, técnica e <span className="text-blue-400">molto lavoro.</span>
        </h1>
        <p className="text-gray-400 mb-6">Bem-vindo ao Canil Ermelino Matarazzo. Nossa missão é oferecer excelência no cuidado, treinamento e bem-estar animal.</p>
        <Link to="/contato" className="inline-block px-6 py-3 bg-blue-600 hover:bg-blue-500 rounded-xl text-white font-semibold transition-all duration-300">
          Fale conosco
        </Link>
      </div>
      <div className="mt-10 md:mt-0 md:ml-12">
        <img src="/cachorro-hero.png" alt="Cão de guarda" className="w-full max-w-md rounded-xl animate-float" />
      </div>
    </section>
  );
}

function Hospedagem() {
  return (
    <section className="px-4 py-12 bg-gray-800 text-center min-h-[calc(100vh-80px)]">
      <img src="/hospedagem.jpg" alt="Hospedagem" className="h-64 md:h-80 object-cover rounded-xl mx-auto mb-6" />
      <h2 className="text-2xl font-bold mb-4">Hospedagem</h2>
      <p className="text-gray-400 max-w-xl mx-auto mb-6">Conforto e segurança para seu cão com estrutura profissional.</p>
      <Link to="/contato?assunto=Quero%20saber%20mais%20sobre%20hospedagem%20para%20meu%20cão" className="inline-block px-6 py-3 bg-blue-600 hover:bg-blue-500 rounded-xl text-white font-semibold transition-all duration-300">
        Quero saber mais
      </Link>
    </section>
  );
}

function Adestramento() {
  return (
    <section className="px-6 py-12 bg-gray-800 text-center min-h-[calc(100vh-80px)]">
      <img src="/adestramento.jpg" alt="Adestramento" className="h-48 md:h-72 object-cover rounded-xl mx-auto mb-6" />
      <h2 className="text-2xl font-bold mb-4">Adestramento</h2>
      <p className="text-gray-400 max-w-xl mx-auto mb-6">Treinamento diário com técnicas modernas e eficientes.</p>
      <Link to="/contato?assunto=Gostaria%20de%20informações%20sobre%20adestramento" className="inline-block px-6 py-3 bg-blue-600 hover:bg-blue-500 rounded-xl text-white font-semibold transition-all duration-300">
        Quero saber mais
      </Link>
    </section>
  );
}

function Cursos() {
  return (
    <section className="px-6 py-12 bg-gray-800 text-center min-h-[calc(100vh-80px)]">
      <img src="/cursos.jpg" alt="Cursos Online" className="h-48 md:h-72 object-cover rounded-xl mx-auto mb-6" />
      <h2 className="text-2xl font-bold mb-2">Cursos Online</h2>
      <p className="text-gray-400 max-w-xl mx-auto">Aprenda com os melhores no conforto da sua casa.</p>
    </section>
  );
}

function Loja() {
  return (
    <section className="px-6 py-16 bg-gray-900 min-h-[calc(100vh-80px)]">
      <h2 className="text-2xl font-bold mb-8 text-center">Loja</h2>
      <div className="grid md:grid-cols-3 gap-8 text-center">
        <div className="bg-gray-800 p-6 rounded-xl">
          <img src="/produto1.png" alt="Produto 1" className="mx-auto mb-4" />
          <h3 className="text-lg font-semibold">Coleira reforçada</h3>
          <p className="text-gray-400 text-sm">Alta durabilidade e conforto</p>
        </div>
        <div className="bg-gray-800 p-6 rounded-xl">
          <img src="/produto2.png" alt="Produto 2" className="mx-auto mb-4" />
          <h3 className="text-lg font-semibold">Brinquedo mordedor</h3>
          <p className="text-gray-400 text-sm">Ideal para cães ativos</p>
        </div>
        <div className="bg-gray-800 p-6 rounded-xl">
          <img src="/produto3.png" alt="Produto 3" className="mx-auto mb-4" />
          <h3 className="text-lg font-semibold">Caminha premium</h3>
          <p className="text-gray-400 text-sm">Conforto absoluto para o descanso</p>
        </div>
      </div>
    </section>
  );
}

export default function HomeCanilParra() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Router>
      <div className="min-h-screen flex bg-gray-900 text-white font-sans">
        <button className="md:hidden fixed top-4 left-4 z-50 bg-gray-800 p-2 rounded" onClick={() => setMenuOpen(!menuOpen)}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 6.75h15m-15 5.25h15m-15 5.25h15" />
          </svg>
        </button>

        <Sidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <main className="md:ml-60 w-full flex flex-col min-h-screen justify-between">
          <Routes>
            <Route path="/" element={<PaginaInicial />} />
            <Route path="/hospedagem" element={<Hospedagem />} />
            <Route path="/adestramento" element={<Adestramento />} />
            <Route path="/cursos" element={<Cursos />} />
            <Route path="/loja" element={<Loja />} />
            <Route path="/contato" element={<Contato />} />
          </Routes>
          <footer className="bg-gray-950 text-center text-gray-500 py-4 text-sm">
            © {new Date().getFullYear()} Canil Ermelino Matarazzo — Todos os direitos reservados.
          </footer>
        </main>
      </div>
    </Router>
  );
}